import { useParamAsInteger } from '@cibo/ui'
import { AvailablePrograms } from 'components/AvailablePrograms'

export const UserPrograms = () => {
  const userId = useParamAsInteger('userId')

  return <AvailablePrograms userId={userId} />
}
